module.exports = __webpack_public_path__ + "media/customizations/regencyatfolsomranch/back-f136210e3b03cb5def521638c2c89f23.jpg";